// extracted by mini-css-extract-plugin
export default {"radio":"Radio_radio__P-CqD","checked":"Radio_checked__Z7fQ0"};